import { render } from "./FosoftechTest.vue?vue&type=template&id=38c2b3c4&scoped=true"
import script from "./FosoftechTest.vue?vue&type=script&lang=js"
export * from "./FosoftechTest.vue?vue&type=script&lang=js"

import "./FosoftechTest.vue?vue&type=style&index=0&id=38c2b3c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c2b3c4"]])

export default __exports__